webpackJsonp([58411574672382],{

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContactQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(8);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// const Contact = ({ data }) => <h1>{data.markdownRemark.frontmatter.mission}</h1>;
	var Contact = function Contact() {
	  return _react2.default.createElement(
	    'section',
	    { className: 'section' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'columns is-multiline' },
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-4 is-offset-4 center is-hidden-desktop' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title is-1' },
	            'Contact'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'column is-4 is-offset-4' },
	          'We are friendly and available to contact. Reach out to us anytime and we will happily answer your question. ',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'form',
	            { id: 'contact-form', action: 'process.php', method: 'post' },
	            _react2.default.createElement('input', { type: 'hidden', name: 'action', defaultValue: 'submit_enquiry' }),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Name'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', { className: 'input', type: 'text', required: 'required', name: 'fullname' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Subject'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control is-expanded' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'select is-fullwidth' },
	                  _react2.default.createElement(
	                    'select',
	                    { required: 'required', name: 'subject' },
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Enquiry' },
	                      'Enquiry'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Membership' },
	                      'Membership'
	                    ),
	                    _react2.default.createElement(
	                      'option',
	                      { value: 'Promotion' },
	                      'Promotion'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'E-mail'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', { className: 'input', type: 'email', required: 'required', name: 'email' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Phone'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('input', { className: 'input', type: 'text', required: 'required', name: 'phone' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'field' },
	              _react2.default.createElement(
	                'label',
	                { className: 'label' },
	                'Message'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'control' },
	                _react2.default.createElement('textarea', { className: 'textarea', name: 'comments', required: 'required', defaultValue: '' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'g-recaptcha', 'data-sitekey': '6LcP4EgUAAAAAAinm0UYHIYW353cGF84npWknwdj' },
	              _react2.default.createElement(
	                'div',
	                { style: { width: 304, height: 78 } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement('iframe', {
	                    src: 'https://www.google.com/recaptcha/api2/anchor?ar=1&k=6LcP4EgUAAAAAAinm0UYHIYW353cGF84npWknwdj&co=aHR0cHM6Ly9ib25nb3V0aW5kb25lc2lhLmNvbTo0NDM.&hl=en&v=v1528855115741&size=normal&cb=5c0neubsbzs6',
	                    width: 304,
	                    height: 78,
	                    role: 'presentation',
	                    frameBorder: 0,
	                    scrolling: 'no',
	                    sandbox: 'allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation allow-modals allow-popups-to-escape-sandbox'
	                  })
	                ),
	                _react2.default.createElement('textarea', {
	                  id: 'g-recaptcha-response',
	                  name: 'g-recaptcha-response',
	                  className: 'g-recaptcha-response',
	                  style: { width: 250, height: 40, border: '1px solid #c1c1c1', margin: '10px 25px', padding: 0, resize: 'none', display: 'none' },
	                  defaultValue: ''
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'control center' },
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('input', { type: 'submit', className: 'button btn-large primary-btn common-btn', defaultValue: 'Send', 'data-label': 'Send' }),
	              _react2.default.createElement(
	                'p',
	                { className: 'form-error', style: { display: 'none' } },
	                _react2.default.createElement('br', null),
	                'Error submiting. Please try again.'
	              )
	            )
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'p',
	            { id: 'alert', style: { fontSize: '1rem', fontWeight: 600 } },
	            '\xA0'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Contact;
	var ContactQuery = exports.ContactQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-5944117e2014e2eef4be.js